export const VIEW_TYPES = {
  LOGIN: 'login',
  RESET: 'reset',
  RESET_SUCCESS: 'resetSuccess',
  PASSWORD_SET: 'passwordSet',
  PASSWORD_SET_SUCCESS: 'passwordSetSuccess'
};

export const AUTH_STATES = {
  OK_AUTH: 'ok',
  NO_AUTH: 'wrong'
};
